<div class="root">
  <div class="row container align-center">
    <app-leaderboard-individual-card></app-leaderboard-individual-card>
  </div>
</div>
